import React from 'react';
import { SdmDialog, SdmTypography } from 'components';
import { theme } from 'theme';

function DeleteDialog({ onAgree, onClose, data, i18n }) {
  return (
    <SdmDialog
      open
      title={i18n.title}
      onAgree={() => {
        onAgree(data);
      }}
      onClose={onClose}
      agreeText={i18n.agreeText}
    >
      <SdmTypography style={{ color: theme.colors.primary.red }}>
        {i18n.message}
      </SdmTypography>
    </SdmDialog>
  );
}

export default DeleteDialog;
